module.exports = __webpack_public_path__ + "static/media/campus-catering-with-food-trucks-3.e92c20d8.jpeg";